// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/custom_action_effect.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/custom_action_effect.proto.
 */
export const file_studyo_today_planners_v1_resources_custom_action_effect = /*@__PURE__*/
  fileDesc("Cj1zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2N1c3RvbV9hY3Rpb25fZWZmZWN0LnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzKqICChJDdXN0b21BY3Rpb25FZmZlY3QSJAogQ1VTVE9NX0FDVElPTl9FRkZFQ1RfVU5TUEVDSUZJRUQQABIkCiBDVVNUT01fQUNUSU9OX0VGRkVDVF9DQU5DRUxfV09SSxABEjEKKUNVU1RPTV9BQ1RJT05fRUZGRUNUX0dPX1RPX0NPTk5FQ1RFRF9BUFBTEAIaAggBEjEKLUNVU1RPTV9BQ1RJT05fRUZGRUNUX0NPTk5FQ1RfR09PR0xFX0NMQVNTUk9PTRADEjAKLENVU1RPTV9BQ1RJT05fRUZGRUNUX0NPTk5FQ1RfR09PR0xFX0NBTEVOREFSEAQSKAokQ1VTVE9NX0FDVElPTl9FRkZFQ1RfQ1JFQVRFX1NDSEVEVUxFEAVCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.planners.v1.resources.CustomActionEffect.
 */
export const CustomActionEffectSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_custom_action_effect, 0);

/**
 * All possible custom actions a special Work item in a planner can allow a user to do.
 *
 * @generated from enum studyo.today.planners.v1.resources.CustomActionEffect
 */
export const CustomActionEffect = /*@__PURE__*/
  tsEnum(CustomActionEffectSchema);

